import { init, dispose, registerIndicator, registerOverlay,IndicatorSeries } from 'klinecharts'
import { createTextEditorModal } from './indicators/text_editor_modal.js'
import {} from "./indicators/ama.js";
import {} from "./indicators/midpoint.js";
import {} from "./indicators/measure.js";
import {} from "./indicators/ema.js";
// ATL and FAT (SATL) Indicator Definitions
const FATL_ARR_JS = [ +0.4360409450, +0.3658689069, +0.2460452079, +0.1104506886, -0.0054034585, -0.0760367731, -0.0933058722, -0.0670110374, -0.0190795053, +0.0259609206, +0.0502044896, +0.0477818607, +0.0249252327, -0.0047706151, -0.0272432537, -0.0338917071, -0.0244141482, -0.0055774838, +0.0128149838, +0.0226522218, +0.0208778257, +0.0100299086, -0.0036771622, -0.0136744850, -0.0160483392, -0.0108597376, -0.0016060704, +0.0069480557, +0.0110573605, +0.0095711419, +0.0040444064, -0.0023824623, -0.0067093714, -0.0072003400, -0.0047717710, +0.0005541115, +0.0007860160, +0.0130129076, +0.0040364019 ];
const SATL_ARR_JS = [ +0.0982862174, +0.0975682269, +0.0961401078, +0.0940230544, +0.0912437090, +0.0878391006, +0.0838544303, +0.0793406350, +0.0743569346, +0.0689666682, +0.0632381578, +0.0572428925, +0.0510534242, +0.0447468229, +0.0383959950, +0.0320735368, +0.0258537721, +0.0198005183, +0.0139807863, +0.0084512448, +0.0032639979, -0.0015350359, -0.0059060082, -0.0098190256, -0.0132507215, -0.0161875265, -0.0186164872, -0.0205446727, -0.0219739146, -0.0229204861, -0.0234080863, -0.0234566315, -0.0231017777, -0.0223796900, -0.0213300463, -0.0199924534, -0.0184126992, -0.0166377699, -0.0147139428, -0.0126796776, -0.0105938331, -0.0084736770, -0.0063841850, -0.0043466731, -0.0023956944, -0.0005535180, +0.0011421469, +0.0026845693, +0.0040471369, +0.0052380201, +0.0062194591, +0.0070340085, +0.0076266453, +0.0080376628, +0.0083037666, +0.0083694798, +0.0082901022, +0.0080741359, +0.0077543820, +0.0073260526, +0.0068163569, +0.0062325477, +0.0056078229, +0.0049516078, +0.0161380976 ];
const DIGITS_JS = 5;

function commonCalcLogicJs(dataList, indicator) {
  let arr = indicator.calcParams == 'FATL' ? FATL_ARR_JS : SATL_ARR_JS;
  const valueKey = indicator.figures[0].key;
  const numPoints = dataList.length;

  if (numPoints < arr.length) {
    return Array(numPoints).fill({});
  }

  const calculatedValuesFull = new Array(numPoints);
  for (let i = 0; i < numPoints; i++) {
    if (i < arr.length - 1) {
      calculatedValuesFull[i] = undefined;
    } else {
      let value = 0.0;
      for (let k = 0; k < arr.length; k++) {
        value += arr[k] * dataList[i - k].close;
      }
      calculatedValuesFull[i] = value;
      // if (i >= arr.length - 1 && i < arr.length - 1 + 5) { // Log first 5 calculable points
      //   console.log(
      //     `Indicator: ${indicator.name}, Index: ${i}, Timestamp: ${dataList[i].timestamp}, ` +
      //     `Close: ${dataList[i].close}, Calculated ${valueKey}: ${calculatedValuesFull[i]}`
      //   );
      // }
    }
  }

  const trendValuesFull = new Array(numPoints);
  for (let i = 0; i < numPoints; i++) {
    if (i < arr.length - 1) {
      trendValuesFull[i] = undefined;
      continue;
    }

    const curValueF = Math.round(calculatedValuesFull[i] * (10**DIGITS_JS)) / (10**DIGITS_JS);

    if (i === arr.length - 1) {
      trendValuesFull[i] = 0;
      continue;
    }

    const preValueF = Math.round(calculatedValuesFull[i - 1] * (10**DIGITS_JS)) / (10**DIGITS_JS);
    const prevTrendState = trendValuesFull[i - 1] === undefined ? 0 : Number(trendValuesFull[i - 1]);

    if (prevTrendState === 0) {
      if (i - 2 < arr.length - 1 || calculatedValuesFull[i - 2] === undefined) { // Check if pre2Value is valid
        trendValuesFull[i] = 0;
      } else {
        const pre2ValueF = Math.round(calculatedValuesFull[i - 2] * (10**DIGITS_JS)) / (10**DIGITS_JS);
        if (pre2ValueF <= preValueF && preValueF > curValueF) {
          trendValuesFull[i] = -1;
        } else if (pre2ValueF >= preValueF && preValueF < curValueF) {
          trendValuesFull[i] = 1;
        } else {
          trendValuesFull[i] = 0;
        }
      }
      // Skip further processing like Ruby's 'next' statement
      continue;
    }

    const diff = curValueF - preValueF;
    if (diff > 0) {
      trendValuesFull[i] = Math.max(prevTrendState, 0) + 1;
    } else if (diff < 0) {
      trendValuesFull[i] = Math.min(prevTrendState, 0) - 1;
    } else {
      trendValuesFull[i] = prevTrendState + Math.sign(prevTrendState);
    }
  }

  const finalOutputArray = new Array(numPoints);
  for (let i = 0; i < numPoints; i++) {
    if (i < arr.length - 1) {
      finalOutputArray[i] = {};
    } else {
      const resultPoint = {};
      resultPoint[valueKey] = calculatedValuesFull[i];
      resultPoint.trend = trendValuesFull[i];
      finalOutputArray[i] = resultPoint;
    }
  }
  return finalOutputArray;
}

const atlIndicator = {
  name: 'ATL',
  shortName: 'ATL',
  series: IndicatorSeries.Price,
  calcParams: FATL_ARR_JS,
  precision: DIGITS_JS,
  shouldOhlc: true,
  figures: [
    {
      key: 'atlValue', title: 'ATL: ', type: 'line',
      styles: ({ data, indicator, defaultStyles }) => {
        const { prev, current } = data
        let trendValue = current?.trend || 0;
        let color = defaultStyles?.line?.color || '#888888'; // Fallback color
        if (trendValue > 0) color = 'green';
        else if (trendValue < 0) color = 'red';
        else if (trendValue === 0) color = 'gray'; // Explicitly gray for 0 trend

        const baseStyles = typeof defaultStyles?.line === 'object' && defaultStyles.line !== null ? { ...defaultStyles.line } : { style: 'solid', size: 1 };
        return { ...baseStyles, color: color };
      },
      xstyles: (figure, kLineData, indicator, defaultStyles) => {
        const trendValue = figure.kLineData?.technicalIndicatorData?.trend;
        let color = defaultStyles?.line?.color || '#888888'; // Fallback color
        if (trendValue > 0) color = 'green';
        else if (trendValue < 0) color = 'red';
        else if (trendValue === 0) color = 'gray'; // Explicitly gray for 0 trend

        const baseStyles = typeof defaultStyles?.line === 'object' && defaultStyles.line !== null ? { ...defaultStyles.line } : { style: 'solid', size: 1 };
        return { ...baseStyles, color: color };
      }
     },
    // {
    //   key: 'trend',
    //   title: 'Trend: ',
    //   type: 'line',
    //   styles: (figure, kLineData, indicator, defaultStyles) => {
    //     const trendValue = figure.kLineData?.technicalIndicatorData?.trend;
    //     let color = defaultStyles?.line?.color || '#888888'; // Fallback color
    //     if (trendValue > 0) color = 'green';
    //     else if (trendValue < 0) color = 'red';
    //     else if (trendValue === 0) color = 'gray'; // Explicitly gray for 0 trend

    //     const baseStyles = typeof defaultStyles?.line === 'object' && defaultStyles.line !== null ? { ...defaultStyles.line } : { style: 'solid', size: 1 };
    //     return { ...baseStyles, color: color };
    //   }
    // }
  ],
  calc: function(dataList, indicator) {
    return commonCalcLogicJs(dataList, indicator);
  }
};

registerIndicator(atlIndicator);

registerIndicator({
  name: "IBS",
  shortName: "IBS",
  figures: [],
  calc: dataList => dataList.map(data => ({
		price: data.high,
		pect: data.high == data.low ? 50 : Math.round(100.0*(data.close - data.low)/(data.high - data.low)),
		up: data.open <= data.close,
		open: data.open,
		close: data.close,
		high: data.high,
    color: data.color,
    cnt: data.cnt,
	})),
  draw: ({ ctx, chart, indicator, bounding, xAxis, yAxis }) => {
    const { from, to } = chart.getVisibleRange();
    const { bar, halfBar, gapBar, halfGapBar } = chart.getBarSpace()
    const { result } = indicator;

    // if(gapBar < 8) return false;
    let fs = gapBar - 4;
    if(fs > 20) fs = 20;
    ctx.font = fs + "px" + " Helvetica Neue";

    ctx.textAlign = "center";
    ctx.fillStyle = 'rgba(128, 128, 128, 0.5)';

    for (let i = from; i < to; i++) {
      const data = result[i];
      if(!data) continue;
      if(data.pect >= 90 && data.up) {
        ctx.fillStyle = 'green'
			} else if(data.pect >= 75 && data.up) {
        ctx.fillStyle = 'rgba(184, 245, 176, 0.5)'
			}
			else if(data.pect <= 10 && !data.up) {
        ctx.fillStyle = 'red'
			} else if(data.pect <= 25 && !data.up) {
        ctx.fillStyle = 'rgba(233, 196, 75, 0.5)'
        ctx.fillStyle = 'rgba(237, 143, 65, 0.5)'
			} else {
				continue;
			}

      // if(data.color)
      //   ctx.fillStyle = data.color
      // else
      //   continue

      // ctx.fillText(data.pect, x, y);

      let x = xAxis.convertToPixel(i) - halfGapBar
      //const y = yAxis.convertToPixel(data.price) - gapBar * 2.5;
      let y = yAxis.convertToPixel(Math.max(data.open, data.close))
			let oh = Math.abs(y	- yAxis.convertToPixel(Math.min(data.open, data.close)));
			let h = oh

			// h = oh > 5 ? 5 : oh
			// if(!data.up) {
			// 	y += oh - h - 1
			// } else {
			// 	y+=1
			// }
			// console.log(data.pect, y, h)

			// ctx.fillRect(x + 1 , y + 1, gapBar - 2, h - 2);
			// console.log(x, y, bar, ":",  h)
			ctx.fillRect(x, y, gapBar, h);
      // ctx.fillText(data.pect, x, y);
      // if(data.cnt)
      //   ctx.fillText(data.cnt, x, y);
    }
    return false;
  },
});

registerIndicator({
  name: "barType",
  figures: [{ key: "price" }],
  calc: (kLineDataList) => {
    return kLineDataList.map((kLineData, index) => {
      let barType = null;
      
      if (index > 2) {
        const bar = kLineDataList[index];
        const pre = kLineDataList[index - 1];
        const pprev = kLineDataList[index - 2];
        const ppprev = kLineDataList[index - 3];
        
        // Check for IOI pattern (inside-outside-inside)
        if (pre.high >= pprev.high && pre.low <= pprev.low && 
            bar.high <= pre.high && bar.low >= pre.low) {
          barType = "ioi";
        } 
        // Check for II pattern (consecutive inside bars)
        else if (pre.high <= pprev.high && pre.low >= pprev.low && 
                bar.high <= pre.high && bar.low >= pre.low) {
          barType = "ii";
        }
        // Check for OO pattern (consecutive outside bars)
        else if (pre.high >= pprev.high && pre.low <= pprev.low && 
                bar.high >= pre.high && bar.low <= pre.low) {
          barType = "oo";
        }
      }
      
      return {
        price: kLineData.high,
        text: barType
      };
    });
  },
  draw: ({ ctx, chart, indicator, bounding, xAxis, yAxis }) => {
    const { from, to } = chart.getVisibleRange();
    const { gapBar, halfGapBar } = chart.getBarSpace()
    const { result } = indicator;
    
    // if(gapBar < 8) return false;
    let fs = gapBar - 4;
    if(fs > 20) fs = 20;
    let padding = 1

    let color = "blue"
    if(indicator.styles.forChart == 'fx') {
      padding = 3
      fs = 15 
      color = "gray"
    }

    ctx.font = fs + "px" + " Helvetica Neue";
    ctx.textAlign = "center";

    for (let i = from; i < to; i++) {
      const data = result[i];
      if(!data || !data.text) continue;
      
      const x = xAxis.convertToPixel(i);
      const y = yAxis.convertToPixel(data.price) - gapBar * 1.5 * padding;
      
      ctx.fillStyle = color;
      ctx.fillText(data.text, x, y);
    }
    return false;
  },
});

registerIndicator({
  name: "3BarMicroChannel",
  shortName: "3BMC",
  figures: [{ key: "price" }],
  calc: (kLineDataList) => {
    const calculateIBS = (bar) => {
      if (bar.high === bar.low) return 50; // Avoid division by zero, neutral IBS
      return 100 * (bar.close - bar.low) / (bar.high - bar.low);
    };

    return kLineDataList.map((kLineData, index) => {
      let channelType = null;
      if (index >= 2) {
        const bar3 = kLineDataList[index]; // Current bar
        const bar2 = kLineDataList[index - 1]; // Previous bar
        const bar1 = kLineDataList[index - 2]; // Bar before previous

        const isBar1Bull = bar1.close >= bar1.open;
        const isBar2Bull = bar2.close >= bar2.open;
        const isBar3Bull = bar3.close >= bar3.open;

        const isBar1Bear = bar1.close <= bar1.open;
        const isBar2Bear = bar2.close <= bar2.open;
        const isBar3Bear = bar3.close <= bar3.open;

        const ibs1 = calculateIBS(bar1);
        const ibs2 = calculateIBS(bar2);
        const ibs3 = calculateIBS(bar3);

        // Bullish 3-bar micro channel
        if (
          isBar1Bull && isBar2Bull && isBar3Bull && // All 3 are bull bars
          bar2.low >= bar1.low && // No pullback bar2 vs bar1
          bar3.low >= bar2.low &&   // No pullback bar3 vs bar2
          ibs1 >= 69 && ibs2 >= 69 && ibs3 >= 69 // All bars IBS > 70
        ) {
          channelType = "bullish";
        }
        // Bearish 3-bar micro channel
        else if (
          isBar1Bear && isBar2Bear && isBar3Bear && // All 3 are bear bars
          bar2.high <= bar1.high && // No pullback bar2 vs bar1
          bar3.high <= bar2.high &&  // No pullback bar3 vs bar2
          ibs1 <= 31 && ibs2 <= 31 && ibs3 <= 31 // All bars IBS < 30
        ) {
          channelType = "bearish";
        }
      }
      return {
        price: channelType === "bullish" ? kLineData.high : kLineData.low,
        text: channelType === "bullish" ? "3B↑" : channelType === "bearish" ? "3B↓" : null,
        channelType: channelType
      };
    });
  },
  draw: ({ ctx, chart, indicator, bounding, xAxis, yAxis }) => {
    const { from, to } = chart.getVisibleRange();
    const { gapBar } = chart.getBarSpace();
    const { result } = indicator;

    let fs = gapBar - 4;
    if (fs > 15) fs = 15;
    if (fs < 8) fs = 8;
    ctx.font = fs + "px Helvetica Neue";
    ctx.textAlign = "center";

    for (let i = from; i < to; i++) {
      const data = result[i];
      if (!data || !data.text) continue;

      const x = xAxis.convertToPixel(i);
      let y;
      if (data.channelType === "bullish") {
        y = yAxis.convertToPixel(data.price) - gapBar * 0.5;
        ctx.fillStyle = "green";
      } else if (data.channelType === "bearish") {
        y = yAxis.convertToPixel(data.price) + gapBar * 0.5 + fs; // Adjust for text baseline
        ctx.fillStyle = "red";
      } else {
        continue;
      }
      ctx.fillText(data.text, x, y);
    }
    return false;
  },
});

registerIndicator({
  name: 'VWAP',
  shortName: 'VWAP',
  series: 'price',
  calcParams: [20],
  // precision: 5,
  shouldOhlc: true,
  figures: [
    { key: 'ema1', title: 'EMA6: ', type: 'line' },
  ],
  regenerateFigures: (params) => params.map((p, i) => ({ key: `ema${i + 1}`, title: `EMA${p}: `, type: 'line' })),
  calc: (dataList, indicator) => {
    const { calcParams: params, figures } = indicator
    return dataList.map((kLineData) => {
      const ema = {}
      params.forEach((_, index) => {
        ema[figures[index].key] = kLineData.vwap
      })
      return ema
    })
  }
})


registerIndicator({
  name: "barTimeCountdown",
  shortName: "BarCountdown",
  figures: [],
  // 添加一个静态变量来跟踪音效状态
  _lastBeepTime: 0,
  _audioContext: null,

  // 播放beep音效的方法
  playBeep(isLastSecond = false) {
    try {
      // 使用Web Audio API创建beep音效
      if (!this._audioContext) {
        this._audioContext = new (window.AudioContext || window.webkitAudioContext)();
      }

      // 确保AudioContext处于运行状态
      if (this._audioContext.state === "suspended") {
        this._audioContext
          .resume()
          .then(() => {
            this._createAndPlaySound(isLastSecond);
          })
          .catch((err) => {
            console.warn("无法恢复音频上下文:", err);
          });
      } else {
        this._createAndPlaySound(isLastSecond);
      }
    } catch (error) {
      console.warn("无法播放音效:", error);
    }
  },

  // 创建并播放声音的内部方法
  _createAndPlaySound(isLastSecond = false) {
    try {
      const oscillator = this._audioContext.createOscillator();
      const gainNode = this._audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(this._audioContext.destination);

      const startTime = this._audioContext.currentTime;
      let duration;

      if (isLastSecond) {
        // 最后一秒：更低频率、更长时间的警告音
        oscillator.frequency.setValueAtTime(400, startTime); // 400Hz低频
        gainNode.gain.setValueAtTime(0.5, startTime); // 更大音量
        duration = 0.8;
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration); // 更长淡出
      } else {
        // 普通倒计时：原来的高频短音
        oscillator.frequency.setValueAtTime(800, startTime); // 800Hz频率
        gainNode.gain.setValueAtTime(0.3, startTime); // 音量
        duration = 0.3;
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration); // 淡出
      }

      // 先start，再stop
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);

      console.log("播放音效:", isLastSecond ? "最后一秒警告音" : "普通倒计时音"); // 调试日志
    } catch (error) {
      console.warn("创建音效失败:", error);
    }
  },

  calc: (dataList) => {
    return dataList.map((data, index) => {
      if (index === dataList.length - 1) {
        // 只在最后一个K线显示倒计时
        return {
          price: data.high,
          timestamp: data.timestamp,
          isLast: true,
        };
      }
      return { price: data.high, isLast: false };
    });
  },
  draw: ({ ctx, chart, indicator, bounding, xAxis, yAxis }) => {
    const { from, to } = chart.getVisibleRange();
    const { gapBar } = chart.getBarSpace();
    const { result } = indicator;

    // 获取原始数据来计算时间间隔
    const dataList = chart.getDataList();
    if (!dataList || dataList.length < 2) return false;

    // 只处理最后一个可见的K线
    const lastIndex = to - 1;
    if (lastIndex < 0 || lastIndex >= result.length) return false;

    const data = result[lastIndex];
    if (!data || !data.isLast) return false;

    // 根据最后两个K线数据计算时间间隔
    const lastData = dataList[dataList.length - 1];
    const secondLastData = dataList[dataList.length - 2];
    const barPeriodMs = lastData.timestamp - secondLastData.timestamp;

    // 获取当前时间
    const now = new Date();
    const currentTimestamp = now.getTime();

    // 计算当前K线的结束时间
    const barStartTime = new Date(lastData.timestamp);
    const barEndTime = new Date(barStartTime.getTime() + barPeriodMs);

    // 计算剩余时间
    let remainingMs = barEndTime.getTime() - currentTimestamp;

    // 如果当前K线已经结束，计算下一个K线的剩余时间
    if (remainingMs <= 0) {
      // 计算已经过去的完整周期数
      const elapsedPeriods = Math.floor(Math.abs(remainingMs) / barPeriodMs);
      // 计算下一个K线的结束时间
      const nextBarEndTime = new Date(barEndTime.getTime() + (elapsedPeriods + 1) * barPeriodMs);
      remainingMs = nextBarEndTime.getTime() - currentTimestamp;
    }

    // 转换为分:秒格式
    const remainingSeconds = Math.floor(remainingMs / 1000);
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    const timeText = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    // 在最后10秒播放beep音效
    if (remainingSeconds <= 5 && remainingSeconds > 0) {
      const currentTime = Math.floor(Date.now() / 1000);
      // 避免重复播放，每秒只播放一次
      if (currentTime !== indicator._lastBeepTime) {
        indicator._lastBeepTime = currentTime;
        // 最后一秒播放不同的声音
        const isLastSecond = remainingSeconds === 1;
        console.log("倒计时音效触发:", remainingSeconds, "秒，最后一秒:", isLastSecond); // 调试日志
        indicator.playBeep(isLastSecond);
      }
    }

    // 设置字体样式
    let fs = Math.min(gapBar + 8, 24); // 增大字体大小
    if (fs < 16) fs = 16; // 最小字体为16px
    ctx.font = `${fs}px Helvetica Neue`;
    ctx.textAlign = "left";
    ctx.textBaseline = "top"; // 设置文字基线为顶部

    // 计算显示位置（最后一个K线的右侧，增加更多间距）
    const x = xAxis.convertToPixel(lastIndex) + gapBar + 15; // 增加间距
    const y = yAxis.convertToPixel(data.price) - 5;

    // 测量文字尺寸
    const textMetrics = ctx.measureText(timeText);
    const textWidth = textMetrics.width;
    const textHeight = fs;

    // 增大背景框的padding
    const bgPadding = 8;

    // 绘制背景
    ctx.fillStyle = "rgba(0, 0, 0, 0.8)"; // 增加背景透明度
    ctx.fillRect(x - bgPadding, y - bgPadding, textWidth + bgPadding * 2, textHeight + bgPadding * 2);

    // 绘制文字
    ctx.fillStyle = remainingMs < 10000 ? "#FF4444" : "#FFA500"; // 使用更鲜艳的颜色
    ctx.fillText(timeText, x, y);

    return false;
  },
});

registerIndicator({
  name: "barCount",
  shortName: "BarCount",
  figures: [],
  // calc: dataList => dataList.map(data => ({ price: data.low, text: data.bar_count})),
  calc: (dataList) => {
    let count = undefined;
    return dataList.map((data) => {
      const timeStr = data.time.split(' ').pop()
      if (timeStr === "15:00:00" || timeStr === "21:30:00") {
        count = 1;
      } else {
        if (count) count += 1;
      }
      return { price: data.low, text: count };
    });
  },
  draw: ({ ctx, chart, indicator, bounding, xAxis, yAxis }) => {
    const { from, to } = chart.getVisibleRange();
    const { gapBar, halfGapBar } = chart.getBarSpace();
    const { result } = indicator;

    if (gapBar < 4) return false;
    let fs = gapBar + 2;
    if (fs > 20) fs = 20;
    ctx.font = fs + "px" + " Helvetica Neue";

    ctx.textAlign = "center";
    ctx.fillStyle = "rgba(128, 128, 128, 0.5)";

    for (let i = from; i < to; i++) {
      const data = result[i];
      if (!data) continue;
      if (data.text % 3 != 0 && data.text != 1) continue;
      const x = xAxis.convertToPixel(i);
      const y = yAxis.convertToPixel(data.price) + gapBar * 1.5;
      if (parseInt(data.text) % 12 == 0) ctx.fillStyle = "rgba(255, 0, 0, 0.7)";
      else if (parseInt(data.text) == 40 || data.text == 1) ctx.fillStyle = "rgba(255, 0, 0, 1)";
      else ctx.fillStyle = "rgba(128, 128, 128, 0.7)";
      ctx.fillText(data.text, x, y);
    }
    return false;
  },
});

registerOverlay({
  name: 'text',
  needDefaultPointFigure: true,
  needDefaultXAxisFigure: false,
  needDefaultYAxisFigure: false,
  totalStep: 2,
  onClick: (e) => {
    createTextEditorModal(e, kchart);
  },
  createPointFigures: ({ chart, coordinates, bounding, overlay, yAxis }) => {
    if (coordinates.length === 1) {
      const text = overlay.extendData.text || '';
      const lines = text.split('\n');
      const size = overlay.extendData.size || 20;
      const baseline = overlay.extendData.baseline || 'middle';
      const lineHeight = size * 1.2;
      
      // console.log('Creating text figures for lines:', lines);
      
      if (lines.length === 1) {
        // Single line - use original logic
        return {
          key: 'text',
          type: 'text',
          attrs: {
            x: coordinates[0].x,
            y: coordinates[0].y,
            text: text,
            align: 'center',
            baseline: baseline,
          },
          styles: {
            size: size,
            style: 'stroke',
            color: overlay.extendData.color || 'blue',
            borderSize: 0,
          }
        }
      } else {
        // Multiple lines - create multiple text figures
        let startY = coordinates[0].y;
        if (baseline === 'middle') {
          startY = coordinates[0].y - ((lines.length - 1) * lineHeight) / 2;
        } else if (baseline === 'top') {
          startY = coordinates[0].y;
        } else { // bottom
          startY = coordinates[0].y - (lines.length - 1) * lineHeight;
        }
        
        return lines.map((line, index) => ({
          key: `text_line_${index}`,
          type: 'text',
          attrs: {
            x: coordinates[0].x,
            y: startY + (index * lineHeight),
            text: line,
            align: 'center',
            baseline: 'middle',
          },
          styles: {
            size: size,
            style: 'stroke',
            color: overlay.extendData.color || 'blue',
            borderSize: 0,
          }
        }));
      }
    }
    return []
  }
})

const parallelogram = {
  name: 'parallelogram',
  totalStep: 4,
  needDefaultPointFigure: true,
  needDefaultXAxisFigure: true,
  needDefaultYAxisFigure: true,
  styles: {
    polygon: {
      color: 'rgba(22, 119, 255, 0.15)'
    }
  },
  createPointFigures: ({ coordinates }) => {
    if (coordinates.length === 2) {
      return [
        {
          type: 'line',
          ignoreEvent: true,
          attrs: { coordinates }
        }
      ]
    }

    if (coordinates.length === 3) {
      const coordinate = { x: coordinates[0].x + (coordinates[2].x - coordinates[1].x), y: coordinates[2].y - coordinates[1].y + coordinates[0].y}
      return [
        {
          type: 'polygon',
          attrs: { coordinates: [coordinates[0], coordinates[1], coordinates[2], coordinate] },
          styles: { style: 'fill' }
        }
      ]
    }
    /*
    if (coordinates.length >= 3) {
      return [
        {
          type: 'polygon',
          attrs: { coordinates: coordinates},
          styles: { style: 'fill' }
        }
      ]
    }
    */
    return []
  },
  performEventPressedMove: ({ points, performPointIndex, performPoint }) => {
    if (performPointIndex < 2) {
      // @ts-expect-error
      points[0].price = performPoint.price
      // @ts-expect-error
      points[1].price = performPoint.price
    }
  },
  performEventMoveForDrawing: ({ currentStep, points, performPoint }) => {
    if (currentStep === 2) {
      // @ts-expect-error
      points[0].price = performPoint.price
    }
  }
}

const fibonacciSegment = {
  name: 'fibonacciSegment',
  totalStep: 3,
  needDefaultPointFigure: true,
  needDefaultXAxisFigure: true,
  needDefaultYAxisFigure: true,
  createPointFigures: ( {chart, coordinates, bounding, overlay, yAxis} ) => {
    const lines = []
    const texts = []
    if (coordinates.length > 1) {
      const textX = coordinates[1].x > coordinates[0].x ? coordinates[0].x : coordinates[1].x
      const percents = [0, 0.5, 1, 2, 3]
      const yDif = coordinates[0].y - coordinates[1].y
      const points = overlay.points
      const valueDif = points[0].value - points[1].value
      const precision = 5;
      percents.forEach(percent => {
        const y = coordinates[0].y - yDif * percent
        const price = coordinates[1].y + yDif * percent
        const value = chart.getDecimalFold().format(chart.getThousandsSeparator().format(((points[0].value ?? 0) + valueDif * percent).toFixed(precision)))
        const actValueDiff = ((points[0].value ?? 0) + valueDif * percent) - (points[0].value ?? 0);
        lines.push({ coordinates: [{ x: coordinates[0].x, y }, { x: coordinates[1].x, y }] })
        texts.push({
          x: textX,
          y,
          text: `${(percent * 100).toFixed(1)} (${(Math.abs(actValueDiff) * 10000).toFixed(1)})`,
          // text: `${(percent).toFixed(1)}`,
          baseline: 'bottom',
          styles: {
            color: 'red'
          }
        })
      })
    }
    return [
      {
        type: 'line',
        attrs: lines,
        styles: {
          style: 'dashed',
          size: 3,
        }
      }, {
        type: 'text',
        ignoreEvent: true,
        attrs: texts,
        styles: {
          color: 'red',
          style: 'stroke',
          borderColor: 'transparent',
        }
      }
    ]
  }
}

registerOverlay(fibonacciSegment);

registerOverlay({
  name: 'rect',
  needDefaultPointFigure: true,
  needDefaultXAxisFigure: true,
  needDefaultYAxisFigure: true,
  totalStep: 3,
  styles: {
    polygon: {
      color: 'red'
    }
  },
  createPointFigures: ({  chart, coordinates, bounding, overlay, yAxis  }) => {
    if (coordinates.length > 1) {
      return [
        {
          type: 'polygon',
          attrs: {
            coordinates: [
              coordinates[0],
              { x: coordinates[1].x, y: coordinates[0].y },
              coordinates[1],
              { x: coordinates[0].x, y: coordinates[1].y }
            ]
          },
          styles: {
            style: 'fill',
            // style: 'fill',
            color: overlay.extendData.color || 'rgba(240, 185, 151, 0.3)',
            //color: 'transparent',
            //borderColor: 'transparent',
          }
        }
      ]
    }
    return []
  }
})

registerOverlay(parallelogram);

function addVLine(chart, id, price, text, color = "green", lock = true, groupId = null, ext_attrs = {size: 3}) {
  let method = "createOverlay";
  let res = chart.getOverlays({id: id, groupId: groupId});
  if (res.length > 0) {
    method = "overrideOverlay";
    if (res[0].is_moving) {
      return;
    }
  }
  chart[method]({
    //console.log({
    name: "verticalStraightLine",
    id: id,
    extendData: text,
    coordinates: [
      { x: price },
      { x: price },
    ],
    points: [
      { timestamp: price },
      { timestamp: price },
    ],
    lock: lock,
    // zLevel: 2,
    // onPressedMoveEnd: lineMoved,
    // onPressedMoveStart: startMove,
    // onRemoved: this.lineRemoved,
    // onRightClick: rightClick,
    groupId: groupId,
    styles: {
      line: {
        size: ext_attrs.size || 2,
        color: color,
        style: ext_attrs.style || "dashed",
      },
      text: {
        color: "white",
        backgroundColor: color,
      },
    },
  });
}

function saveOverlays(kchart, filter) {
  let res = kchart.getOverlays(filter);
  let items = res.map(o => (
    {
      name: o.name,
      id: o.id,
      groupId: o.groupId,
      paneId: o.paneId,
      lock: o.lock,
      visible: o.visible,
      zLevel: o.zLevel,
      mode: o.mode,
      modeSensitivity:  o.modeSensitivity,
      points: o.points,
      extendData: o.extendData,
      styles: o.styles
    }
  ))

  return items;
}



function addLine(chart, id, price, text, color = "green", lock = true, groupId = null, ext_attrs = {}) {
  let method = "createOverlay";
  let res = chart.getOverlays({id: id, groupId: groupId});
  if (res.length>0) {
    console.log(res)
    method = "overrideOverlay";
    // let value = res.points[0].value;
    // // console.log(id, value);
    // if (value == price) {
    //   return;
    // }
    if (res.is_moving) {
      return;
    }
    // console.log("same price", id, value, price, res.is_moving);
  }
  chart[method]({
    name: "simpleTag",
    id: id,
    extendData: text,
    points: [{ value: price }],
    lock: lock,
    // onPressedMoveEnd: lineMoved,
    // onPressedMoveStart: startMove,
    // onRemoved: this.lineRemoved,
    // onRightClick: rightClick,
    groupId: groupId,
    styles: {
      line: {
        size: ext_attrs.size || 2,
        color: color,
        style: ext_attrs.style || "dashed",
      },
      text: {
        color: "white",
        backgroundColor: color,
      },
    },
  });
}

function setShapeType(kchart, name, styles={},ext_attrs = {}, points = []) {
  return kchart.createOverlay({
    name: name,
    groupId: "draw",
    zLevel: -9999,
    mode: 'weak_magnet',
    onDrawEnd: kchart.saveDrawObjects,
    // onRemoved: window.saveDrawObjects,
    // onPressedMoveEnd: window.saveDrawObjects,
    // onClick: (e) => {
    //   createTextEditorModal(e, kchart);
    // },
    extendData: ext_attrs,
    styles: styles,
    points: points
  });
}

function setShapeTypeTemp(kchart, name, styles={},attrs = {}, points = []) {
  let id = 'temp_draw'
  return kchart.createOverlay({
    name: name,
    id: id,
    groupId: "draw",
    onDrawEnd: (overlay) => {
      kchart.removeOverlay({id: id});
    },
    // onRemoved: window.saveDrawObjects,
    // onPressedMoveEnd: window.saveDrawObjects,
    extendData: attrs,
    styles: styles,
    points: points
  });
}

function drawObject(key, kchart) {
  let style ='dashed'

  if(key == 'e') {
    kchart.removeOverlay({groupId: 'draw'})
  }

  if(key == 'h') {
    setShapeType(kchart, 'horizontalSegment', {line: {color: 'orange', size: 3, style: style}})
  }
  if(key == 'd') {
    setShapeType(kchart, 'horizontalStraightLine', {line: {color: 'gray', size: 2, style: style}})
  }
  if(key == 'w') {
    setShapeType(kchart, 'segment', {line: {color: 'red', size: 3, style: style}})
  }
  if(key == 't') {
    setShapeType(kchart, 'segment', {line: {color: 'blue', size: 3, style: style}})
  }
  if(key == 'n') {
    setShapeType(kchart, 'text', {}, {text: 'add Text here', align: 'center', color: 'red', baseline: 'bottom', size: 16})
  }
  if(key == 'c') {
    setShapeType(kchart, 'parallelogram', {}, {})
  }
  if(key == '`') {
    setShapeTypeTemp(kchart, 'measure', {}, {})
  }
  if(key == 'r') {
    setShapeType(kchart, 'fibonacciSegment', {}, {})
  }
  if(key == 'g') {
    setShapeType(kchart, 'rect', {}, {})
  }
  if(key == 'b') {
    setShapeType(kchart, 'text', {}, {
      color: 'green',
      text: "️🢁",
      baseline: 'top',
      size: 20,
    })
  }

  if(key == 'p') {
    saveOverlays(kchart, {groupId: 'draw'})
  }

  if(key == 's') {
    setShapeType(kchart, 'text', {}, {
      color: 'red',
      text: '🢃',
      baseline: 'bottom',
      size: 20,
    })
  }
}

function formatData(data) {
  return data.map(row => ({
    timestamp: new Date(row.timestamp).getTime(),
    open: row.open,
    high: row.high,
    low: row.low,
    close: row.close,
    volume: row.volume
  }));
}

function initHisChart(element, klineBars) {
  const chart = init(element);
  const formattedBars = formatData(klineBars);
  chart.applyNewData(formattedBars);
  return chart;
}

function drawHisTradeLine(chart, entry, exit, tradeType, draw_entry = true) {
  const isLong = tradeType === 'buy' || tradeType === 'long';
  const isProfit = isLong ? exit.price > entry.price : exit.price < entry.price;
  let color = isProfit ? 'gray' : 'blue';
  color = isLong ? 'green' : 'red';

  chart.createOverlay({
    name: 'segment',
    points: [
      { timestamp: entry.time, value: entry.price },
      { timestamp: exit.time, value: exit.price }
    ],
    styles: {
      line: {
        color: color,
        size: 2
      }
    }
  })

  if(!draw_entry) {
    return;
  }
  chart.createOverlay({
    name: 'segment',
    points: [
      { timestamp: entry.time - 3000 * 1000, value: entry.price - 30 * ( isLong ? 1 : -1 ) },
      { timestamp: entry.time - 300 * 1000, value: entry.price - 5 * ( isLong ? 1 : -1 ) }
    ],
    styles: {
      line: {
        color: 'black',
        width: 10,
        size: 4
      }
    }
  })
}


export { init, dispose, addLine, addVLine, drawObject, saveOverlays, setShapeType, initHisChart, drawHisTradeLine }
